<template>
  <div>
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody" :label="$t('Importación de Inventarios')">
        <section class="container">
          <h1>Importación de Inventario</h1>
          <el-row :gutter="40">
            <el-col :sm="12">
              <h4>Seleccione tipo contrato</h4>
              <el-select v-model="typeContract" placeholder="Seleccione tipo de contrato" style="width: 100%">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <div v-if="typeContract === 'propio'">
                <h4>Seleccione un contrato</h4>
                <el-select filterable v-model="selectedContractPropio" placeholder="Seleccione contrato"
                  @change="contractSelectedPropio" style="width: 100%">
                  <el-option v-for="contract in propios" :key="contract._id" :label="contract.nombre"
                    :value="contract._id"></el-option>
                </el-select>
                <br />
                <br />
                <span class="info">
                  <i class="el-icon-info"></i> Sí no encuentra su contrato,
                  verifique que se encuentren correctamente ingresadas las
                  fechas de inicio y fin.
                </span>
              </div>
              <div v-if="typeContract === 'contratista'">
                <h4>Seleccione empresa</h4>
                <el-select v-model="selectedCompany" @change="companySelected" filterable
                  placeholder="Seleccione empresa" style="width: 100%">
                  <el-option v-for="company in companies" :key="company._id" :label="company.nombre"
                    :value="company._id"></el-option>
                </el-select>
              </div>
              <div v-if="selectedCompany && typeContract === 'contratista'">
                <h4>Seleccione contrato</h4>
                <el-select v-model="selectedContract" @change="contractSelected" filterable
                  placeholder="Seleccione contrato" style="width: 100%">
                  <el-option v-for="contract in getContracts(selectedCompany)" :key="contract._id"
                    :label="contract.nombre" :value="contract._id"></el-option>
                </el-select>
                <br />
                <br />
                <span class="info">
                  <i class="el-icon-info"></i> Sí no encuentra su contrato,
                  verifique que se encuentren correctamente ingresadas las
                  fechas de inicio y fin.
                </span>
              </div>
            </el-col>
            <el-col :sm="12">
              <h4>Seleccione archivo CSV a importar</h4>
              <input type="file" @click="clear($event)" @change="inventarioFileChanged($event.target.files)" />
            </el-col>
            <el-col :sm="24" v-if="!!Object.keys(riskTypeReplace).length && errors.length > 0">
              <br />
              <h1>
                <span style="color: red">ERROR:</span> Tipos de impactos no
                soportados por la plataforma
              </h1>
              <small style="color: red">Debe corregirlos en primera instancia para continuar con la
                importación</small>
              <br />
              <br />
              <small>
                <b>
                  <span style="color: red">(*)</span>
                </b>
                Reemplace los riesgos del listado por los correctos y luego
                oprima "corregir tipos de impactos" para reemplazarlos.
                <br />
                <b>Tipos de impactos soportados: Salud, Seguridad y
                  Medioambiente.</b>
              </small>
              <br />
              <br />
              <div v-for="(obj, i) in riskTypeReplace" :key="i">
                <el-form label-position="top">
                  <el-form-item style="margin-bottom: 0px !important" label="Tipo de impacto">
                    <el-input style="width: 400px" size="small" v-model="riskTypeReplace[i]"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div>
                <br />
                <el-button type="primary" @click="reReadCSV" :loading="loading">Corregir tipos de impactos</el-button>
              </div>
            </el-col>
          </el-row>

          <div v-if="CSVReady">
            <br />
            <div v-if="errors.length > 0" style="color: gray">
              <h3>Errores({{ errors.length }})</h3>
              <p>Debe solucionar estos errores antes de poder importar</p>
              <ul>
                <li v-for="(error, i) in errors" :key="i">{{ error }}</li>
              </ul>
            </div>
            <el-button type="primary" @click="importInventory" v-if="errors.length == 0" :loading="loading">Importar
              Inventario</el-button>
            <br />
            <br />
            <br />
            <h2>Previsualización</h2>
            <h4>
              Seleccione alguna
              <b>TAREA</b> para desplegar más información
            </h4>
            <el-collapse :model="activeTasks">
              <el-collapse-item v-for="tarea in inventario.tareas" :key="tarea.id">
                <template slot="title">
                  <br />
                  <br />
                  <div @click="changeTaskShowObj(tarea.id)" class="contenedor_tarea">
                    <span class="titleCollapseTask">{{
                        truncarTexto(tarea.nombre)
                    }}</span>
                    <el-tag type="success" style="margin-left: 20px" v-if="tarea.riesgos">{{ tarea.riesgos.length }}
                      riesgos</el-tag>
                    <el-tag type="warning" style="margin-left: 20px" v-else>0 riesgos</el-tag>
                  </div>
                  <br />
                  <br />
                </template>
                <keep-alive>
                  <InventarioTable v-if="taskShowObj[tarea.id]" :risks.sync="tarea.riesgos"
                    :withStatus="inventario.status > 0" :task="tarea" />
                </keep-alive>
                <div v-for="(a, i) in aaa" v-bind:key="i"></div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </section>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="Información" :visible.sync="dialogInformacion" width="30%" :before-close="handleClose">
      <br />
      <span v-if="typeMessage === 'inventoryExist'">
        El contrato que has seleccionado ya tiene asociado un inventario de
        riesgos, para realizar la importación debes seleccionar un contrato que
        no posea ningúna matriz de riesgos cargada.
        <br />
        <br />Si no posees un contrato en la plataforma para realizar la
        importación puedes crear uno accediendo desde el siguiente enlace.
      </span>
      <span v-else>
        La empresa que has seleccionado no posee ningún contrato asociado en la
        plataforma, Para continuar con el proceso de importación puedes crear un
        contrato accediendo desde el siguiente enlace.
      </span>
      <br />
      <br />
      <br />
      <center>
        <el-button @click="createContract()" size="small" icon="el-icon-plus" type="primary">Crear un contrato
        </el-button>
      </center>
    </el-dialog>

    <el-dialog title="Faltan tareas en su inventario" :visible.sync="dialogPendientes" width="30%"
      :before-close="handleClose">
      <div style="margin-top: 10px">
        <span><i style="margin-right: 8px" class="el-icon-info"></i>Para continuar
          se debe incorporar las siguientes tareas a su inventario de riesgos o
          bien si ya las tiene incorporadas con un nombre diferente puede
          sustituirlas oprimiendo el boton indicado en la tabla.</span>
        <el-table :data="tareas_pendientes" row-class-name="rowClassTablaPloma" cell-class-name="cellClassTablaPloma"
          header-cell-class-name="header-cell-class-table-gray" style="width: 100%; margin-top: 20px">
          <el-table-column prop="nombre" label="Nombre"> </el-table-column>
          <el-table-column align="center" label="Sustituir" width="100">
            <template slot-scope="scope">
              <el-button @click="remplazar(scope.row)" size="small" type="primary">Sustituir</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogPendientes = false" size="small" type="danger">Cancelar</el-button>
      </span>
    </el-dialog>

    <el-dialog append-to-body title="Sustituir tareas en su inventario" :visible.sync="dialogSustituir" width="30%">
      <div style="margin-top: 10px">
        <span>Nombre de la tarea seleccionada: </span>
        <b>{{ replace_task.nombre }}</b>
      </div>
      <div style="margin-top: 10px">
        <span>Seleccione las tareas que desea sustituir: </span>
        <el-table ref="multipleTable" @selection-change="handleSelectionChange" :data="inventario.tareas"
          row-class-name="rowClassTablaPloma" cell-class-name="cellClassTablaPloma"
          header-cell-class-name="header-cell-class-table-gray" style="width: 100%; margin-top: 20px">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="nombre" label="Nombre de la tarea">
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sustituirTareas" size="small" type="primary">Sustituir</el-button>
        <el-button @click="
          dialogSustituir = false;
        toggleSelection();
        " size="small" type="danger">Cancelar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import uuid from "uuid/v4";
import csv from "csvtojson";
import snakeCase from "snake-case";
import moment from "moment";
import InventarioTable from "../../components/InventarioTable";

export default {
  components: {
    InventarioTable,
  },
  data() {
    return {
      tareas_seleccionadas: [],
      replace_task: {},
      dialogSustituir: false,
      dialogPendientes: false,
      tareas_pendientes: [],
      contract: {},
      inputFileEvent: "",
      typeMessage: "",
      dialogInformacion: false,
      CSVReady: false,
      loading: false,
      activeTasks: null,
      selectedContract: null,
      selectedCompany: null,
      errors: [],
      riskTypeReplace: {},
      inventario: {
        status: 0,
        tareas: [],
        usuario_creador_id: null,
        empresa_id: null,
        contrato_id: null,
      },
      typeContract: "",
      selectedContractPropio: null,
      ownContract: [],
      options: [
        {
          value: "contratista",
          label: "Contratista",
        },
        {
          value: "propio",
          label: "Propio",
        },
      ],
      taskShowObj: {},
      aaa: [], // no me borren porfavor
      isIE11: false,
    };
  },
  created() {
    this.$store.dispatch("setSubTitle", "Administración de importaciones");
    this.$store.dispatch("getAllRisks");
    this.$store.dispatch("getContractsFaena");
    this.$store.dispatch("getCompanyContractsInventory");
    this.$store.dispatch("getOwnContractsWithInventory");
    this.isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  },
  computed: {
    risks() {
      return this.$store.getters.allRisks;
    },
    propios() {
      return this.$store.getters.contracts_own;
    },
    companies() {
      return this.$store.getters.empresasCI;
    },
  },
  methods: {
    sustituirTareas() {
      this.$confirm(
        "Estás a punto de reemplazar el nombre de las tareas seleccionadas en el inventario de riesgos",
        "Advertencia",
        {
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      )
        .then(() => {
          this.tareas_seleccionadas.forEach((t) => {
            t["nombre"] = this.replace_task.nombre;
          });
          this.$notify({
            title: "Información",
            message:
              "Las tareas seleccionadas han sido sustituidas exitosamente.",
            type: "success",
          });
          this.dialogSustituir = false;
          this.dialogPendientes = false;
        })
        .catch(() => { });
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.tareas_seleccionadas = val;
    },
    remplazar(task) {
      this.replace_task = task;
      this.dialogSustituir = true;
    },
    eliminarDiacriticos(texto) {
      return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
    truncarTexto(texto) {
      if (texto.length > 174) {
        return `${texto.slice(0, 179)} ...`;
      }
      return texto;
    },
    handleClose() {
      this.dialogPendientes = false;
      this.dialogInformacion = false;
      if (this.typeMessage === "inventoryExist") {
        this.selectedContract = null;
        this.selectedContractPropio = null;
      }
      if (this.typeMessage === "emptyContracts") {
        this.selectedCompany = null;
      }
    },
    createContract() {
      this.$router.push({ name: "contractCreateStep1" });
    },
    getHumanDate(date) {
      return moment(date, "YYYY-MM-DD");
    },
    isValidDateContract(contract) {
      return moment(this.getHumanDate(new Date())).isSameOrBefore(
        this.getHumanDate(contract.fecha_fin)
      );
    },
    getContracts(id) {
      try {
        return this.$store.getters.empresasCI.find((x) => x._id === id)
          .contratos;
      } catch (error) {
        console.log(error);
      }
    },
    changeTaskShowObj(i) {
      this.taskShowObj[i] = !this.taskShowObj[i];
      this.taskShowObj[i] ? this.aaa.push("a") : this.aaa.pop();
    },
    contractSelectedPropio() {
      const self = this;
      const contract = this.$store.getters.contracts_own.find(
        (x) => x._id === this.selectedContractPropio
      );
      if (!contract.inventario) {
        this.contract = contract;
        this.inventario.contrato_id = contract._id;
        this.inventario.area_id = contract.area_id;
        this.inventario.usuario_creador_id = contract.coordinator_id;
      } else {
        this.dialogInformacion = true;
        this.typeMessage = "inventoryExist";
        this.contract = {};
      }
    },
    getMFL(risk) {
      let mfl = 0;
      if (risk.impactos) {
        risk.impactos.forEach((impacto) => {
          if (impacto.mfl > mfl) {
            mfl = impacto.mfl;
          }
        });
      }
      return mfl;
    },
    isRiskReady(risk) {
      let isReady = true;
      if (!risk.custom || risk.custom === false) {
        return true;
      }
      if (!risk.causas || risk.causas.length === 0) {
        return false;
      }
      if (!risk.impactos || risk.impactos.length === 0) {
        return false;
      }
      risk.causas.forEach((causa) => {
        if (
          !causa.controles_preventivos ||
          causa.controles_preventivos.length === 0
        ) {
          isReady = false;
        }
      });
      if (!isReady) {
        return false;
      }

      risk.impactos.forEach((impacto) => {
        if (
          !impacto.controles_mitigadores ||
          impacto.controles_mitigadores.length === 0
        ) {
          isReady = false;
        }
        if (
          !impacto.descripcion ||
          !impacto.categoria ||
          !impacto.factor_severidad ||
          !impacto.nivel_severidad ||
          !impacto.factor_probabilidad ||
          !impacto.mfl
        ) {
          isReady = false;
        }
      });
      if (!isReady) {
        return false;
      }
      return true;
    },
    importInventory(typeContract) {
      this.$confirm(
        "Se procederá a importar inventario a este contrato. Estás seguro?",
        "Atención",
        {
          confirmButtonText: "Sí",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      ).then(() => {
        this.loading = true;
        // Status 3 es 'Importado sin aprobar'
        const inventario = Object.assign({}, this.inventario, {
          imported: true,
          status: 3,
          created_at: this.inventario.created_at || new Date(),
        });
        let isReady = true;
        // let onlyStandardized = true
        inventario.tareas.forEach((tarea) => {
          if (!tarea.riesgos) {
            isReady = false;
            return;
          }
          tarea.riesgos.forEach((riesgo) => {
            // if (riesgo.custom) {
            //   onlyStandardized = false
            // }
            if (!this.isRiskReady(riesgo)) {
              isReady = false;
            }
          });
        });
        if (!isReady) {
          this.loading = false;
          this.$alert(
            "Falta información en algunos riesgos. Por favor revise e intente nuevamente",
            "Atención",
            {
              type: "error",
            }
          );
          return;
        }

        // Solo Riesgos estandarizados, asi que se aprueba automaticamente
        // if (onlyStandardized) {
        //   inventario.status = 2
        // }

        // Borra DraftID si es que hay uno.
        localStorage.removeItem("draftID");

        this.$store.dispatch("setInventario", { ...inventario }).then(() => {
          this.$store.dispatch("createOrUpdateDraft").then(() => {
            this.$store
              .dispatch("saveInventario")
              .then((response) => {
                if (response.status) {
                  this.$message({
                    type: "success",
                    message: "Inventario importado exitosamente",
                  });
                  const inv = this.$store.getters.inventario;
                  for (const i in inv.tareas)
                    this.taskShowObj[inv.tareas[i].id] = false;
                  this.CSVReady = false;
                  this.inventario.tareas = [];
                  (this.typeMessage = ""),
                    (this.dialogInformacion = false),
                    (this.CSVReady = false);
                  this.selectedContract = null;
                  this.selectedCompany = null;
                  this.errors = [];
                  this.inventario.status = 0;
                  this.inventario.usuario_creador_id = null;
                  this.inventario.empresa_id = null;
                  this.inventario.contrato_id = null;
                  this.typeContract = "";
                  this.selectedContractPropio = null;
                  this.riskTypeReplace = {};
                  /* setTimeout(function() {
                    location.reload();
                  }, 6000); */
                } else {
                  this.$alert(
                    response.message,
                    "Error al importar inventario",
                    {
                      type: "error",
                    }
                  );
                }
                this.loading = false;
              })
              .catch((error) => {
                this.$alert(error, "Error al conectarse a servidor", {
                  type: "error",
                });
                this.loading = false;
              });
          });
        });
      });
    },
    companySelected() {
      this.selectedContract = null;
      const company = this.companies.find(
        (obj) => obj._id === this.selectedCompany
      );
      if (company.contratos && company.contratos.length === 0) {
        this.dialogInformacion = true;
        this.typeMessage = "emptyContracts";
      }
    },
    contractSelected(id) {
      const company = this.companies.find(
        (obj) => obj._id === this.selectedCompany
      );
      const contrato = company.contratos.find((obj) => obj._id === id);
      if (contrato.inventario && contrato.inventario.length === 0) {
        this.contract = contrato;
        this.inventario.contrato_id = contrato._id;
        this.inventario.empresa_id = company._id;
        this.inventario.usuario_creador_id = contrato.contractor_coordinator_id;
      } else {
        this.dialogInformacion = true;
        this.typeMessage = "inventoryExist";
        this.contract = {};
      }
    },
    clear(event) {
      event.target.value = null;
    },
    inventarioFileChanged(files) {
      const reader = new FileReader();
      reader.readAsText(files[0], "ISO-8859-3");
      reader.onload = this.readCSV;
    },
    reReadCSV() {
      this.readCSV(this.inputFileEvent);
    },
    readCSV(event) {
      this.CSVReady = false;
      this.errors = [];
      const _csv = event.target.result;
      this.inputFileEvent = event;

      if (typeof String.prototype.trimRight !== "function") {
        //  esto no esta en internet explorer
        String.prototype.trimRight = function () {
          return this.replace(/[\s\xa0]+$/, "");
        };
      } // if

      let ultimaTarea = null;
      let ultimoRiesgo = null;
      let ultimaCausa = null;

      csv({
        flatKeys: true,
        delimiter: "auto",
      })
        .fromString(_csv)
        .on("json", (jsonObj, rowIndex) => {
          const _tarea = jsonObj.Tarea || ultimaTarea;
          const _riesgo = jsonObj.Riesgo || ultimoRiesgo;
          const _causa = jsonObj.Causa || ultimaCausa;
          const _controlPreventivo = jsonObj["Control Preventivo"];
          let _tipoImpacto = jsonObj.Impacto;
          const _descripcionImpacto = jsonObj["Descripcion Impacto"];
          const _controlMitigador = jsonObj["Control Mitigador"];
          const _MFL = jsonObj.MFL;
          const _factorSeveridad = jsonObj["Factor de Severidad"];
          const _factorProbabilidad = jsonObj["Factor de Probabilidad"];
          const _NSR = jsonObj.NSR;

          // Configura tarea
          let tarea = {};
          const tareaIndex = this.inventario.tareas.findIndex(
            (elem) => elem.nombre === _tarea
          );

          if (tareaIndex >= 0) {
            tarea = this.inventario.tareas[tareaIndex];
          } else {
            tarea.id = uuid();
            tarea.nombre = _tarea;
            tarea.riesgos = [];
          }

          // Configura riesgo
          let riesgo = {};
          const riesgoIndex = tarea.riesgos.findIndex(
            (elem) => snakeCase(elem.nombre) === snakeCase(_riesgo)
          );

          // Se comprueba si es riesgo material
          // Si es así, se agrega completamente
          const riesgoMaterialIndex = this.risks.findIndex(
            (elem) => snakeCase(elem.nombre) === snakeCase(_riesgo)
          );

          if (riesgoMaterialIndex >= 0) {
            // Si es riesgo material
            riesgo = this.risks[riesgoMaterialIndex];
          } else {
            // validar tipo de riesgo, si no el workflow no funciona y por ende no se podra evaluar
            // _tipoImpacto es la var q se usa para tipo de riesgo
            if (
              _tipoImpacto &&
              !["salud", "seguridad", "medioambiente"].includes(
                _tipoImpacto.toLowerCase()
              )
            ) {
              // si encuentra en los remplazos cambia el tipo
              if (
                this.riskTypeReplace[_tipoImpacto] &&
                ["salud", "seguridad", "medioambiente"].includes(
                  this.riskTypeReplace[_tipoImpacto].toLowerCase()
                )
              ) {
                _tipoImpacto = this.riskTypeReplace[_tipoImpacto].toLowerCase();
              } else {
                this.errors.push(
                  `Falta información o es erronea en fila ${rowIndex + 2
                  }. tipo impacto debe ser salud, seguridad o medioambiente.
                    tipo impacto ingresado: ${_tipoImpacto}`
                );
                this.riskTypeReplace[_tipoImpacto] = _tipoImpacto;
                return;
              }
            } // if

            // Validacion de campos los otros campos
            if (
              !_tarea ||
              !_riesgo ||
              !_causa ||
              !_controlPreventivo ||
              !_tipoImpacto ||
              !_descripcionImpacto ||
              !_controlMitigador ||
              !_MFL ||
              !_factorSeveridad ||
              !_factorProbabilidad ||
              !_NSR
            ) {
              this.errors.push(
                `Falta información en fila ${rowIndex + 2
                }. Riesgo "${_riesgo}" no será agregado.`
              );
              return;
            }

            // No es riesgo material, asi que se crea
            if (riesgoIndex >= 0) {
              riesgo = tarea.riesgos[riesgoIndex];
            } else {
              riesgo._id = uuid();
              riesgo.nombre = _riesgo;
              riesgo.tipo = _tipoImpacto;
              riesgo.custom = true;
              riesgo.causas = [];
              riesgo.impactos = [];
              riesgo.status = 0;
              riesgo.status_step = 0;
            }
            // Configura causa
            let causa = {};
            const causaIndex = riesgo.causas.findIndex(
              (elem) => elem.nombre === _causa
            );

            if (causaIndex >= 0) {
              causa = riesgo.causas[causaIndex];
            } else {
              causa.id = uuid();
              causa.nombre = _causa;
              causa.controles_preventivos = [];
            }

            // Configura controles preventivos
            if (_controlPreventivo) {
              let controlPreventivo = {};
              const controlPreventivoIndex =
                causa.controles_preventivos.findIndex(
                  (elem) => elem.nombre === _controlPreventivo
                );

              if (controlPreventivoIndex >= 0) {
                controlPreventivo =
                  causa.controles_preventivos[controlPreventivoIndex];
              } else {
                controlPreventivo.id = uuid();
                controlPreventivo.causaId = causa.id;
                controlPreventivo.id_causa =
                  causaIndex >= 0
                    ? `CA${causaIndex + 1}`
                    : `CA${riesgo.causas.length + 1}`;
                controlPreventivo.nombre = _controlPreventivo;
              }

              // Guarda controles preventivos en causa
              if (controlPreventivoIndex >= 0) {
                causa.controles_preventivos[controlPreventivoIndex] =
                  controlPreventivo;
              } else {
                causa.controles_preventivos.push(controlPreventivo);
              }
            }

            // Guarda causa en riesgo
            if (causaIndex >= 0) {
              riesgo.causas[causaIndex] = causa;
            } else {
              riesgo.causas.push(causa);
            }

            // Configura impacto (siempre solo uno)
            let impacto = {};
            const impactoIndex = riesgo.impactos.findIndex(
              (elem) => elem.categoria === _tipoImpacto
            );

            if (impactoIndex >= 0) {
              impacto = riesgo.impactos[impactoIndex];
            } else {
              impacto.id = uuid();
              impacto.categoria = _tipoImpacto;
              impacto.descripcion = _descripcionImpacto;
              impacto.factor_severidad = parseFloat(
                _factorSeveridad.replace(/,/g, ".")
              );
              impacto.factor_probabilidad = parseFloat(
                _factorProbabilidad.replace(/,/g, ".")
              );
              impacto.nivel_severidad = parseFloat(_NSR.replace(/,/g, "."));
              impacto.mfl = _MFL;
              impacto.controles_mitigadores = [];
            }

            if (_controlMitigador) {
              // Configura controles mitigadores
              let controlMitigador = {};
              const controlMitigadorIndex =
                impacto.controles_mitigadores.findIndex(
                  (elem) => elem.nombre === _controlMitigador
                );

              if (controlMitigadorIndex >= 0) {
                controlMitigador =
                  impacto.controles_mitigadores[controlMitigadorIndex];
              } else {
                controlMitigador.id = uuid();
                controlMitigador.impactoId = impacto.id;
                controlMitigador.id_impacto =
                  impactoIndex >= 0
                    ? `IM${impactoIndex + 1}`
                    : `IM${riesgo.impactos.length + 1}`;
                controlMitigador.nombre = _controlMitigador;
              }

              // Guarda controles mitigadores en impacto
              if (controlMitigadorIndex >= 0) {
                impacto.controles_mitigadores[controlMitigadorIndex] =
                  controlMitigador;
              } else {
                impacto.controles_mitigadores.push(controlMitigador);
              }
            }

            // Guarda impacto en riesgo
            if (impactoIndex >= 0) {
              riesgo.impactos[impactoIndex] = impacto;
            } else {
              riesgo.impactos.push(impacto);
            }
          }

          // Guarda riesgo en tarea
          if (riesgoIndex >= 0) {
            tarea.riesgos[riesgoIndex] = riesgo;
          } else {
            tarea.riesgos.push(riesgo);
          }

          // Guarda tarea completa en inventario
          if (tareaIndex >= 0) {
            this.inventario.tareas[tareaIndex] = tarea;
          } else {
            this.inventario.tareas.push(tarea);
          }

          ultimaTarea = _tarea;
          ultimoRiesgo = _riesgo;
          ultimaCausa = _causa;
        })
        .on("done", (error) => {
          this.CSVReady = true;
          if (error) {
            this.$alert(error, "Atención", {
              type: "error",
            });
          }
        });
    }, //
  },
};
</script>

<style scoped>
.contenedor_tarea {
  width: 100%;
  position: absolute;
  z-index: 2;
}

.info {
  font-size: 13px;
  color: gray;
}
</style>
